import { DialogContent } from "@mui/material";
import PasswordInput from "common/components/PasswordInput/PasswordInput";

export const DialogResetPasswordContent = ({
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
}) => {
    return (
        <DialogContent>
            <PasswordInput
                label="Nueva contraseña"
                setData={setNewPassword}
                data={newPassword}
            />
            <PasswordInput
                label="Confirmar contraseña"
                setData={setConfirmPassword}
                data={confirmPassword}
            />
        </DialogContent>
    );
};
